var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C14.9413 12.007 13.9279 12.4307 13.1793 13.1793C12.4307 13.9279 12.007 14.9413 12 16C12 18.1893 13.8107 20 16 20C18.188 20 20 18.1893 20 16C20 13.812 18.188 12 16 12Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.177 16.462C3.202 16.53 3.24 16.625 3.292 16.747C3.429 17.068 3.591 17.403 3.773 17.743C4.172 18.489 4.865 19.615 5.902 20.742C8.545 23.612 11.982 25.067 16.119 25.067C20.257 25.067 23.694 23.612 26.337 20.742C27.372 19.617 28.066 18.49 28.466 17.744C28.645 17.409 28.807 17.074 28.947 16.746C28.997 16.627 29.036 16.531 29.06 16.464L29.207 16.033L29.061 15.603C29.037 15.537 28.998 15.441 28.947 15.321C28.808 14.996 28.646 14.66 28.467 14.324C28.067 13.577 27.372 12.451 26.337 11.326C23.696 8.456 20.258 7 16.12 7C11.981 7 8.544 8.456 5.902 11.326C4.868 12.45 4.174 13.577 3.773 14.324C3.544 14.752 3.385 15.102 3.292 15.321C3.241 15.442 3.203 15.538 3.178 15.604L3.16 15.652L3 15.654L3.143 15.7L3.031 16.034L3.177 16.462ZM5.276 15.914C5.976 14.308 8.824 9.067 16.12 9.067C23.414 9.067 26.264 14.308 26.964 15.914L27.015 16.034L26.964 16.152C26.264 17.759 23.417 23 16.12 23C8.823 23 5.976 17.759 5.276 16.153L5.224 16.033L5.276 15.914Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsShow);
export default __webpack_public_path__ + "static/media/icons-show.2a1c3fb09812eb5709b457dde859663b.svg";
export { ForwardRef as ReactComponent };